/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

type Props<T> = Omit<React.ComponentProps<'input'>, 'value'> & {
  value: T;
  onChange?: (value: T, event: any) => void;
};

function Radio<T>(props: Props<T>) {
  let { onChange, style, value, ...otherProps } = props;
  let onChangeHandler = (event: any) => {
    // TODO: This doesn't seem right.
    if (event.target.checked) {
      onChange?.(props.value, event);
    }
  };
  let componentStyle = style || {};
  return (
    <span className="rdio" style={componentStyle}>
      <input {...otherProps} type="radio" onChange={onChangeHandler} />
      <span />
    </span>
  );
}

export default Radio;
